import { useTranslation } from 'react-i18next';

import useAppModal from 'hooks/useAppModal';
import { ScheduledMessage } from 'models/automation/ScheduledMessages';
import ScheduledMessagesRescheduleModal from './ScheduledMessagesRescheduleModal';

const modalId = 'scheduled-messages-reschedule-modal';

const useScheduledMessagesRescheduleModal = () => {
  const { openModal } = useAppModal();
  const { t } = useTranslation();

  const openRescheduleScheduledMessagesModal = ({
    scheduledMessage,
  }: {
    scheduledMessage: ScheduledMessage;
  }) => {
    openModal({
      customContent: (
        <ScheduledMessagesRescheduleModal scheduledMessage={scheduledMessage} />
      ),
      id: modalId,
      title: t('pageAutomations.scheduledMessages.modalReschedule.title'),
    });
  };

  return { openRescheduleScheduledMessagesModal };
};

export default useScheduledMessagesRescheduleModal;
